import * as React from 'react';
import PropTypes from 'prop-types';
import CssBaseline from '@mui/material/CssBaseline';
import {
  CssVarsProvider,
  experimental_extendTheme as extendTheme,
} from '@mui/material/styles';

import { inputsCustomizations } from './customizations/inputs';
import { dataDisplayCustomizations } from './customizations/dataDisplay';
import { feedbackCustomizations } from './customizations/feedback';
import { navigationCustomizations } from './customizations/navigation';
import { surfacesCustomizations } from './customizations/surfaces';

import {
  colorSchemes,
  typography,
  shadows,
  shape,
  green, // required for direct reference in override
} from './themePrimitives';

const theme = extendTheme({
  cssVarPrefix: 'template',
  colorSchemes,
  typography,
  shadows,
  shape,
  components: {
    ...inputsCustomizations,
    ...dataDisplayCustomizations,
    ...feedbackCustomizations,
    ...navigationCustomizations,
    ...surfacesCustomizations,
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained', color: 'primary' },
          style: {
            color: '#106a41',
            backgroundColor: '#fff',
            border: '2px solid #106a41',
            backgroundImage: 'none',
            boxShadow: 'none',
      
            '&:hover': {
              backgroundColor: '#106a41',
              color: '#fff !important',
            },
            '&:active': {
              backgroundColor: '#106a41',
              color: '#fff !important',
            },
            '&:focus': {
              backgroundColor: '#106a41',
              color: '#fff !important',
            },
            '&:focus-visible': {
              backgroundColor: '#106a41',
              color: '#fff !important',
            },
          },
        },
        {
          props: { variant: 'text', color: 'info' },
          style: {
            color: '#000',
            backgroundColor: '#fff',
            backgroundImage: 'none',
            padding: '5px 10px',
      
            '&:hover': {
              backgroundColor: '#106a41',
              color: '#ffffff !important'
            },
            '&:active': {
              backgroundColor: '#106a41',
              color: '#ffffff !important'
            },
            '&:focus': {
              backgroundColor: '#106a41',
              color: '#ffffff !important'
            },
            '&:focus-visible': {
              backgroundColor: '#106a41',
              color: '#ffffff !important'
            },
          },
        },
      ],
    },
  },
});

export default function AppTheme({ children, disableCustomTheme }) {
  if (disableCustomTheme) {
    return <>{children}</>;
  }

  return (
    <CssVarsProvider theme={theme} defaultMode="light" disableTransitionOnChange>
      <CssBaseline enableColorScheme />
      {children}
    </CssVarsProvider>
  );
}

AppTheme.propTypes = {
  children: PropTypes.node,
  disableCustomTheme: PropTypes.bool,
};